import React, { useEffect, useState } from 'react';
import "./Events.css";
import { firestore, auth } from "../../firebase/firebaseConfig";
import { setDoc, doc, onSnapshot } from '@firebase/firestore';
import { onAuthStateChanged } from "firebase/auth"
import { Button, Input } from 'antd';

function Events () {
    let [ events, setEvents ] = useState( [] );

    async function onload () {
        onSnapshot( doc( firestore, "GlobalConfigurations/Events" ), ( snapshot ) => {
            setEvents( [ ...snapshot.data().events ] );
            document.querySelector( ".sending-loader" ).style.display = "none";
        } );
    }

    useEffect( () => {
        document.querySelector( ".sending-loader" ).style.display = "flex";
        document.querySelectorAll( ".ant-menu-item" )[ 8 ].click();
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onload();
            } else {
                window.location.href = "/login";
            }
        } );
    }, [] );

    return (
        <div className='making-container'>
            <form onSubmit={async event => {
                event.preventDefault();
                document.querySelector( ".sending-loader" ).style.display = "flex";
                let array = events;
                array.push( event.target.event_name.value );

                await setDoc( doc( firestore, "GlobalConfigurations", "Events" ), {
                    events: array
                } )

                event.target.reset();
                document.querySelector( ".sending-loader" ).style.display = "none";
            }} className="making-container-top-container">
                <Input style={{ width: "180px" }} type="text" placeholder='Enter Event' className='event-name' name='event_name' required />
                <Button htmlType='submit'>Add Event</Button>
            </form>
            <div className="all-make-city-container" style={{ width: "95%" }}>
                Events
            </div>
            <div className='all-make-entries-container'>
                {events.map( ( element, index ) => (
                    <div style={{ alignItems: "center", width: "100%", justifyContent: "space-between" }} className='all-make-entry-container'>
                        <h5 style={{ color: "white" }}>{element}</h5>
                        <Button danger onClick={async event => {
                            document.querySelector( ".sending-loader" ).style.display = "flex";
                            events.splice( index, 1 );

                            await setDoc( doc( firestore, "GlobalConfigurations", "Events" ), {
                                events: events
                            } )
                            document.querySelector( ".sending-loader" ).style.display = "none";
                        }}>Delete Event</Button>
                    </div>
                ) )}
            </div>
        </div>
    )
}

export default Events